import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const services = [
  {
    icon: 'ri-code-s-slash-line',
    title: 'Développement logiciel',
    description:
      'Création de solutions sur mesure adaptées aux besoins spécifiques de votre entreprise. De la conception à la mise en production.',
  },
  {
    icon: 'ri-global-line',
    title: 'Développement web',
    description:
      'Conception de sites et applications modernes, performants et optimisés pour une expérience utilisateur optimale.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Maintenance et support',
    description:
      'Suivi technique rigoureux et assistance continue des solutions informatiques mises en place pour votre activité.',
  },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-white font-[Manrope,sans-serif]">
      <Navbar />

      {/* Hero */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Background image */}
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://public.readdy.ai/ai/img_res/ea0ed089571e94f19eb35b0fcf35549d.jpg"
            alt="CICHORZ - Développement informatique Paris"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-[#0A1628]/90 via-[#0A1628]/80 to-[#1a2f4f]/85" />
        </div>

        {/* Grid pattern overlay */}
        <div
          className="absolute inset-0 opacity-5"
          style={{
            backgroundImage:
              'linear-gradient(rgba(255,255,255,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.3) 1px, transparent 1px)',
            backgroundSize: '60px 60px',
          }}
        />

        {/* Content */}
        <div className="relative z-10 w-full max-w-5xl mx-auto px-6 lg:px-10 text-center">
          <p className="text-[#7ec8ff] text-xs font-semibold tracking-[4px] uppercase mb-6">
            Programmation Informatique — Paris
          </p>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 tracking-tight max-w-4xl mx-auto">
            Développement informatique et solutions digitales
          </h1>
          <p className="text-white/70 text-lg md:text-xl font-light leading-relaxed max-w-2xl mx-auto mb-10">
            CICHORZ propose des services de programmation informatique pour les entreprises et les particuliers.
            Des solutions fiables, performantes et adaptées à chaque besoin.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/contact"
              className="px-8 py-4 bg-white text-[#0A1628] font-bold text-sm tracking-widest uppercase rounded-full hover:-translate-y-1 hover:shadow-xl transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Contactez-nous
            </Link>
            <Link
              to="/a-propos"
              className="px-8 py-4 border border-white/40 text-white font-medium text-sm tracking-widest uppercase rounded-full hover:border-white hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              En savoir plus
            </Link>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/40">
          <span className="text-xs tracking-widest uppercase">Défiler</span>
          <div className="w-px h-8 bg-white/30" />
        </div>
      </section>

      {/* Services */}
      <section className="py-28 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="flex flex-col items-center text-center mb-16">
            <span className="inline-block px-4 py-1.5 border border-gray-200 rounded-full text-xs font-semibold tracking-widest uppercase text-gray-500 mb-6">
              Nos services
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#0A1628] max-w-2xl leading-tight">
              Solutions techniques adaptées à vos besoins
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {services.map((service) => (
              <div
                key={service.title}
                className="group bg-[#F7F8FA] rounded-2xl p-10 hover:-translate-y-2 transition-all duration-300 cursor-default"
              >
                <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-[#0A1628] mb-6">
                  <i className={`${service.icon} text-white text-2xl`} />
                </div>
                <h3 className="text-xl font-bold text-[#0A1628] mb-3">{service.title}</h3>
                <p className="text-[#4A5568] text-sm leading-relaxed">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Approach */}
      <section className="py-28 bg-[#F7F8FA]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            {/* Text */}
            <div>
              <span className="inline-block px-4 py-1.5 border border-gray-300 rounded-full text-xs font-semibold tracking-widest uppercase text-gray-500 mb-6">
                Notre approche
              </span>
              <h2 className="text-4xl md:text-5xl font-bold text-[#0A1628] leading-tight mb-6">
                Rigueur,<br />
                <span className="font-light text-[#6B7280]">efficacité et expertise</span>
              </h2>
              <p className="text-[#374151] text-lg leading-relaxed mb-8">
                Chaque projet est réalisé avec rigueur afin de proposer des solutions efficaces,
                sécurisées et évolutives. L&apos;objectif est de comprendre précisément les besoins
                pour y répondre de manière concrète et durable.
              </p>
              <ul className="flex flex-col gap-4 mb-10">
                {[
                  'Solutions sur mesure et évolutives',
                  'Code propre, maintenable et sécurisé',
                  'Accompagnement et support technique',
                ].map((item) => (
                  <li key={item} className="flex items-center gap-3 text-[#374151] text-sm">
                    <span className="w-5 h-5 flex items-center justify-center rounded-full bg-[#0A1628]">
                      <i className="ri-check-line text-white text-xs" />
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
              <Link
                to="/a-propos"
                className="inline-flex items-center gap-2 text-[#0A1628] font-semibold text-sm tracking-wide hover:gap-4 transition-all duration-200 cursor-pointer"
              >
                En savoir plus sur CICHORZ
                <i className="ri-arrow-right-line" />
              </Link>
            </div>

            {/* Image grid */}
            <div className="relative h-[480px]">
              <div className="absolute top-0 left-0 w-56 h-56 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=clean%20modern%20software%20developer%20workspace%20desk%20with%20multiple%20monitors%20showing%20code%20dark%20navy%20blue%20and%20white%20minimalist%20setup%20professional%20environment%20Paris%20office%20clean%20aesthetic%20simple%20background&width=400&height=400&seq=about01&orientation=squarish"
                  alt="Développement logiciel"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute bottom-0 right-0 w-72 h-80 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=close%20up%20professional%20coding%20programming%20screen%20displaying%20clean%20code%20syntax%20dark%20background%20blue%20accent%20colors%20modern%20software%20development%20terminal%20IDE%20minimalist%20clean%20technology%20professional&width=500&height=600&seq=about02&orientation=portrait"
                  alt="Solutions informatiques"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Stats badge */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-2xl p-5 shadow-lg">
                <div className="flex items-center gap-6">
                  <div className="text-center">
                    <p className="text-3xl font-bold text-[#0A1628]">10+</p>
                    <p className="text-xs text-[#6B7280] mt-1">ans d&apos;expérience</p>
                  </div>
                  <div className="w-px h-10 bg-gray-200" />
                  <div className="text-center">
                    <p className="text-3xl font-bold text-[#0A1628]">100%</p>
                    <p className="text-xs text-[#6B7280] mt-1">satisfaction</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-28 bg-[#0A1628]">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
            Prêt à démarrer votre projet ?
          </h2>
          <p className="text-white/60 text-lg mb-10 leading-relaxed max-w-xl mx-auto">
            Contactez-nous pour discuter de vos besoins et obtenir une estimation gratuite.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-3 px-10 py-4 bg-white text-[#0A1628] font-bold text-sm tracking-widest uppercase rounded-full hover:-translate-y-1 hover:shadow-2xl transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Contactez-nous
            <i className="ri-arrow-right-line text-base" />
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
